import { createAction } from 'redux-actions';
import types from '../types';

export const displayScene = createAction(types.DISPLAY_SCENE);
